/* tslint:disable */
/* eslint-disable */
/**
 * Oil refinery process modeling system
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.2.4
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {mapValues} from '../runtime';
/**
 *
 * @export
 * @interface RJSFSchemas
 */
export interface RJSFSchemas {
  /**
   *
   * @type {object}
   * @memberof RJSFSchemas
   */
  jsonSchema: object;
  /**
   *
   * @type {{ [key: string]: object; }}
   * @memberof RJSFSchemas
   */
  ui: {[key: string]: object};
  /**
   *
   * @type {string}
   * @memberof RJSFSchemas
   */
  tabName: string;
  /**
   *
   * @type {string}
   * @memberof RJSFSchemas
   */
  tabCode?: string | null;
  /**
   *
   * @type {{ [key: string]: object; }}
   * @memberof RJSFSchemas
   */
  data: {[key: string]: object};
}

/**
 * Check if a given object implements the RJSFSchemas interface.
 */
export function instanceOfRJSFSchemas(value: object): value is RJSFSchemas {
  if (!('jsonSchema' in value) || value['jsonSchema'] === undefined) return false;
  if (!('ui' in value) || value['ui'] === undefined) return false;
  if (!('tabName' in value) || value['tabName'] === undefined) return false;
  if (!('data' in value) || value['data'] === undefined) return false;
  return true;
}

export function RJSFSchemasFromJSON(json: any): RJSFSchemas {
  return RJSFSchemasFromJSONTyped(json, false);
}

export function RJSFSchemasFromJSONTyped(json: any, ignoreDiscriminator: boolean): RJSFSchemas {
  if (json == null) {
    return json;
  }
  return {
    jsonSchema: json['json_schema'],
    ui: json['ui'],
    tabName: json['tab_name'],
    tabCode: json['tab_code'] == null ? undefined : json['tab_code'],
    data: json['data']
  };
}

export function RJSFSchemasToJSON(value?: RJSFSchemas | null): any {
  if (value == null) {
    return value;
  }
  return {
    json_schema: value['jsonSchema'],
    ui: value['ui'],
    tab_name: value['tabName'],
    tab_code: value['tabCode'],
    data: value['data']
  };
}
